import { Component, OnInit, ViewChild } from '@angular/core';
import { faUser, faLock, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import { User } from '../user';
import { AuthenticationService } from '../authentication.service';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              private router: Router) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  faUser = faUser;
  faLock = faLock;
  faEyeSlash = faEyeSlash;
  faEye = faEye;

  loginUser: User = new User();
  returnUrl: string;
  error = "";
  alertClosed = false;
  hidePassword = true;

  @ViewChild('loginForm')
  form: any;

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onSubmit() {
    this.authenticationService.login(this.loginUser.username, this.loginUser.password)
      .pipe(first())
      .subscribe(
        data => {
          this.router.navigate([this.returnUrl]);
        },
        error => {
          this.error = "Error on login";
          if (error && error.error) {
            this.error += ": Code=" + error.error.errorCode;
            if (error.error.errorDetails) {
              this.error += ", Details=" + error.error.errorDetails;
            }
          }
        }
      );
  }

  toggleHidePassword () {
    this.hidePassword = !this.hidePassword;
  }

  closeAlert() {
    
  }
}
